import TruncateText from '@creditflowresearch/uilib/TruncateText';

import styles from '@/creditflowresearch/ui/components/bondscreener/Cells/cells.module.scss';

export interface ITicker {
  id: string,
  name: string,
  ticker: string | null,
  url?: string,
}

export interface IIssuerTickerCellProps {
  ticker: ITicker | null | undefined,
}

const IssuerTickerCell = ({ ticker }: IIssuerTickerCellProps) => {
  if (!ticker) {
    return (<>-</>);
  }

  const display = ticker.ticker || ticker.name;

  return (
    <TruncateText value={ ticker.name } className={ styles.tickerBadge } shouldShowTooltip>
      { display }
    </TruncateText>
  );
};

export default IssuerTickerCell;
